import { render, staticRenderFns } from "./BarGraphByLabel.vue?vue&type=template&id=25b638ca"
import script from "./BarGraphByLabel.vue?vue&type=script&lang=js"
export * from "./BarGraphByLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports